





















































import Vue from "vue";

export default Vue.extend({
  name: "cwx-text-field",

  props: {
    //Appends an icon to the component
    appendIcon: String,
    //Adds input clear functionality (default icon is "icon-remove")
    clearable: Boolean,
    //Applied when using clearable and the input is dirty
    clearIcon: {
      type: String,
      default: "icon-remove"
    },
    //Applies specified color to the control
    color: {
      type: String,
      default: "#3561A0"
    },
    //Disable the input
    disabled: Boolean,
    //Adds an id to the <input> element
    inputId: String,
    //Sets input label
    label: {
      type: String,
      default: undefined
    },
    //Sets the input’s placeholder text
    placeholder: String,
    //Specifies that an <input> is readonly
    readonly: Boolean,
    //Label does not move on focus/dirty
    singleLine: {
      type: Boolean,
      default: false
    },
    //Input value
    value: {
      type: String,
      required: false,
      default: undefined
    }
  },

  data() {
    return {
      isFocused: false,
      initialValue: null,
      lazyValue: this.value as any,
      internalChange: false,
      hasMouseDown: false
    };
  },

  computed: {
    focused(): boolean {
      return !this.singleLine && this.isFocused;
    },

    labelFor(): string | null {
      return this.inputId ? this.inputId : null;
    },

    inputAriaLabel(): any {
      return !this.inputId && this.label;
    },

    inpId(): string | null {
      return this.inputId ? this.inputId : null;
    },

    inputPlaceholder(): string | null {
      return this.placeholder ? this.placeholder : null;
    },

    isDirty(): boolean {
      return this.lazyValue != null && this.lazyValue.toString().length > 0;
    },

    showLabel(): any {
      return (
        this.label && (!this.singleLine || (!this.isDirty && !this.placeholder))
      );
    },

    labelChangedDisplay(): boolean {
      return (
        !this.singleLine &&
        Boolean(this.isFocused || this.isDirty || this.placeholder)
      );
    },

    internalValue: {
      get(): any {
        return this.lazyValue;
      },
      set(val: string | null): any {
        this.lazyValue = val;
        this.$emit("input", this.lazyValue);
      }
    }
  },

  watch: {
    value(val) {
      this.lazyValue = val;
    },

    isFocused(val) {
      if (val) {
        this.initialValue = this.lazyValue;
      } else if (this.initialValue !== this.lazyValue) {
        this.$emit("change", this.lazyValue);
      }
    }
  },

  methods: {
    onFocus(e: Event) {
      if (!this.$refs.input) return;
      if (document.activeElement !== this.$refs.input) {
        return (this.$refs.input as HTMLInputElement).focus();
      }
      if (!this.isFocused) {
        this.isFocused = true;
      }
    },

    onBlur(e: Event) {
      this.isFocused = false;
      this.internalChange = false;
    },

    onKeyDown(e: KeyboardEvent) {
      this.internalChange = true;
    },

    onKeyUp(e: KeyboardEvent) {
      if (e.keyCode === 13) {
        e.preventDefault();
        e.stopPropagation();
        this.$emit("keyup-enter", e);
      }
    },

    onInput(e: any) {
      this.internalChange = true;
      this.internalValue = e.target.value;
    },

    onMouseDown(e: Event) {
      // Prevent input from being blurred
      if (e.target !== this.$refs.input) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.hasMouseDown = true;
    },

    onMouseUp(e: Event) {
      if (this.hasMouseDown) {
        (this.$refs.input as HTMLInputElement).focus();
      }
      this.hasMouseDown = false;
    },

    onClick(e: Event) {
      if (this.isFocused || this.disabled) return;
      (this.$refs.input as HTMLInputElement).focus();
    },

    onClickClearIcon() {
      this.internalValue = null;
      this.$nextTick(() => (this.$refs.input as HTMLInputElement).focus);
      this.$emit("click-append-icon");
    },

    onClickAppendIcon(e: Event) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit("click-append-icon", e);
    }
  }
});
